import qs from 'qs'

export default function ppcReducer(state = {
  settings:   {},
  management: {
    list:   [],
    paging: {
      number: 1,
      size:   10
    },
    links: {}
  },
  loads: {
    list: [],
    paging: {
      number: 1,
      size:   10
    },
  },
  load: {},
  kycStatues: {},
  orderStatuses: [],
  fetching:   false,
  fetched:    false,
  errors:     {}
}, action) {
  switch (action.type) {
    case 'GET_PPC_SETTINGS_PENDING':
    case 'GET_PPC_MANAGEMENT_LIST_PENDING':
    case 'GET_PPC_USER_PENDING':
    case 'GET_PCC_LOAD_EUROS_PENDING':
    case 'GET_PPC_USER_LOADS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    }
    case 'GET_PPC_SETTINGS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched:  true,
        settings: action.payLoad,
      }
    }
    case 'GET_PPC_MANAGEMENT_LIST_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.management.paging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }

      return {
        ...state,
        fetching:   false,
        fetched:    true,
        management: {
          list:   action.payLoad.data,
          paging: page,
          links: action.payLoad.links
        }
      }
    }
    case 'GET_PPC_USER_FULFILLED': {
      return {
        ...state,
        fetching:   false,
        fetched:    true,
        user: action.payLoad.data,
        kycStatuses: action.payLoad.meta['kyc-statuses']
      }
    }
    case 'GET_PPC_USER_LOADS_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.loads.paging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }

      return {
        ...state,
        fetching:   false,
        fetched:    true,
        loads: {
          list: action.payLoad.data,
          paging: page
        }
      }
    }
    case 'GET_PPC_USER_LOAD_FULFILLED': {
      return {
        ...state,
        fetching:   false,
        fetched:    true,
        load: action.payLoad.data,
        orderStatuses: action.payLoad.meta.statuses,
        loadLinks: action.payLoad.links
      }
    }
    case 'GET_PPC_USER_MANUAL_LOAD_FULFILLED': {
      return {
        ...state,
        fetching:   false,
        fetched:    true,
        load: action.payLoad.data,
        loadLinks: action.payLoad.links
      }
    }
    case 'GET_PCC_LOAD_EUROS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
      }
    }
    case 'GET_PPC_SETTINGS_REJECTED':
    case 'GET_PPC_MANAGEMENT_LIST_REJECTED':
    case 'GET_PPC_USER_REJECTED':
    case 'GET_PCC_LOAD_EUROS_REJECTED':
    case 'GET_PPC_USER_LOADS_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'CLEAR_EDIT_PPC_LOAD':
    case 'CLEAR_EDIT_PPC_MANUAL_LOAD': {
      return {
        ...state,
        load: {}
      }
    }
    default:
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/ppcReducer.js